import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getAnalytics } from 'firebase/analytics';
import firebaseConfigDev from 'firebase.config.dev';
import firebaseConfigProd from 'firebase.config.prod';
import environment from './environment';

const firebaseConfig = environment.environment === 'prod' ? firebaseConfigProd : firebaseConfigDev;

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
const analytics = getAnalytics(app);
